import React from "react";
import { RouteObject } from "react-router-dom";
import ResourcesLanding from "./components/list/Landing";
import AddToWarehouse from "./components/create/AddToWarehouse";
import AddInstalled from "./components/create/AddInstalled";
import ResourceDetailLanding from "./components/detail/Landing";
import MeterReaderManagement from "../settings/components/ServiceExecutives/MeterReaderManagement";

export interface mxResourcesRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxResourcesRoute[];
}

export const mxResourcesRoutes: mxResourcesRoute[] = [
  {
    path: "mx/manage/resources",
    element: <ResourcesLanding />,
  },
  {
    path: "mx/manage/resources/create/warehouse",
    element: <AddToWarehouse />,
  },
  {
    path: "mx/manage/resources/create/installed",
    element: <AddInstalled />,
  },
  {
    path: "mx/manage/resources/view/:id",
    element: <ResourceDetailLanding />,
  },
  {
    path: "mx/manage/resources/edit/warehouse/:id",
    element: <AddToWarehouse />,
  },
  {
    path: "mx/manage/resources/edit/installed/:id",
    element: <AddInstalled />,
  },
  {
    path: 'mx/manage/field-technician',
    element: <MeterReaderManagement />
  },
];
